export const editorTranslationsEn: Record<string, string> = {
  // Поиск по карте и объектам
  'Поиск': 'Search',
  'Очистить': 'Clear',
  'Объекты проекта': 'Project features',
  'Места и POI': 'Places & POIs',
  'Не удалось выполнить поиск': 'Search failed',
  // Типы мест (geo_places) — обратный перевод для EN-интерфейса
  'город': 'city',
  'село': 'village',
  'деревня': 'hamlet',
  'район': 'district',
  'местность': 'locality',
  'остров': 'island',
  'страна': 'country',
  'регион': 'region',
  'провинция': 'province',
  'нац. парк': 'national park',
  'заповедник': 'nature reserve',
  'охраняемая территория': 'protected area',
  'лес': 'forest',
  'парк': 'park',
  'военный объект': 'military',
  'университет': 'university',
  'станция': 'station',
  'метро': 'subway',
  'остановка': 'bus stop',
  'музей': 'museum',
  'кафе': 'cafe',
  'ресторан': 'restaurant',
  'Мне нужна карта в тёмных тонах...': 'I need a dark map...',
  'Добавить значение': 'Add value',
  'Добавить': 'Add',
  'Кликните для переименования': 'Click to rename',
  'Без раскраски': 'No data-driven colors',
  'Обложка': 'Cover',
  '**Жирный** *курсив* [ссылка](url)': '**Bold** *italic* [link](url)',
  'Удалить параметр': 'Delete property',
  'Мой стиль': 'My style',
  'Параметр…': 'Property…',
  'Загрузить свою иконку (PNG, WebP, SVG)': 'Upload custom icon (PNG, WebP, SVG)',
  'Как в списке слоя': 'As shown in the layer list',
  'Выберите поле': 'Select field',
  'Загрузить иконку (PNG, JPG, WebP, SVG)': 'Upload icon (PNG, JPG, WebP, SVG)',
  'Описание слоя (поддерживает markdown)...': 'Layer description (Markdown supported)...',
  'от': 'from',
  'до': 'to',
  'Выбор цвета обводки точки с превью': 'Choose preview point stroke color',
  'Выбор цвета фона свободной формы': 'Choose freeform background color',
  'Цвет на остановке зума': 'Color at zoom stop',
  'Отключить изменение по зуму': 'Disable zoom-based styling',
  'Описание стиля': 'Style description',
  'Опишите желаемый стиль карты словами (например: «тёмная карта с яркой водой и оранжевыми дорогами»)': 'Describe the desired map style (for example: “a dark map with bright water and orange roads”)',
  'Генерирую...': 'Generating...',
  'Сгенерировать стиль': 'Generate style',
  'Название темы': 'Theme name',
  'Рекомендуемое название:': 'Suggested name:',
  'Сохранить тему': 'Save theme',
  'Раскраска по параметру': 'Color by property',
  'Добавьте поля в схему данных ниже, чтобы раскрашивать объекты по значению.': 'Add fields to the data schema below to color features by value.',
  'Без раскраски (один цвет)': 'No data-driven colors (single color)',
  'У объектов нет значений для этого поля. Заполните поле в карточке каждого объекта.': 'Features have no values for this field. Fill it in for each feature.',
  'Палитра цветов': 'Color palette',
  'Своя палитра': 'Custom palette',
  'Снять выбор': 'Clear selection',
  'Добавить файл': 'Add file',
  'Параметры объектов': 'Feature properties',
  'Задайте параметры, которые можно заполнять для объектов этого слоя.': 'Define properties that can be filled in for features in this layer.',
  'Добавить параметр': 'Add property',
  'Высота 3D (extrusion)': '3D height (extrusion)',
  'Добавьте в схему слоя числовые параметры — здесь можно выбрать поле высоты вместо выражения в paint.': 'Add numeric properties to the layer schema to use a height field instead of a paint expression.',
  'Высота по параметру': 'Height by property',
  'Параметр не выбран': 'No property selected',
  'Коэффициент высоты': 'Height multiplier',
  'Значение параметра умножается на коэффициент (например, 3 для этажей).': 'The property value is multiplied by this number (for example, 3 for floors).',
  'Fallback высота (м)': 'Fallback height (m)',
  'Высота, если значение параметра отсутствует или не положительное.': 'Height used when the property is missing or not positive.',
  'Кол-во': 'Count',
  'Проценты': 'Percent',
  'Вид': 'Display',
  'Диапазон': 'Range',
  'Таймлайн': 'Timeline',
  'Диапазонов': 'Ranges',
  'Показывать гистограмму': 'Show histogram',
  'Фильтры для публичной карты': 'Public map filters',
  'Добавьте в схему слоя параметры типа «строка», «число», «логический», «массив» или «выбор», чтобы настроить фильтры для публичной карты.': 'Add string, number, boolean, array, or select properties to the layer schema to configure public map filters.',
  'Фильтры позволяют пользователям отбирать объекты по параметрам на публичной карте.': 'Filters let visitors select features by property on the public map.',
  'Выберите параметр': 'Select a property',
  'Добавить фильтр': 'Add filter',
  'У объектов нет значений для этого поля. Заполните поле в карточке каждого объекта или задайте варианты в схеме параметра.': 'Features have no values for this field. Fill it in for each feature or define options in the property schema.',
  'Свои иконки по значениям': 'Custom icons by value',
  'Выбрано объектов:': 'Selected features:',
  '. Изменения параметров применяются ко всем выбранным.': '. Property changes apply to all selected features.',
  'Параметры объекта': 'Feature properties',
  'Стиль изображения': 'Image style',
  'Значения — по первому выбранному объекту; изменение применится ко всем выбранным.': 'Values are shown for the first selected feature; changes apply to all selected features.',
  'Заменить файл': 'Replace file',
  'Добавить изображение в слой': 'Add image to layer',
  'Расположение': 'Position',
  'Перемещайте изображение на карте мышью. Alt+колесо — масштаб. Shift+колесо — поворот.': 'Drag the image on the map. Alt+wheel scales it; Shift+wheel rotates it.',
  'Изображения в слое': 'Images in layer',
  'В слое:': 'In layer:',
  '. Выберите объект в списке слоя или на карте, чтобы заменить файл или править подпись.': '. Select a feature in the layer list or on the map to replace the file or edit its label.',
  'Добавить стиль из другого проекта': 'Add style from another project',
  'Стиль будет скопирован в этот проект как отдельная запись. Изменения в копии не затронут оригинал.': 'The style will be copied into this project. Changes to the copy will not affect the original.',
  'Не удалось загрузить список стилей.': 'Could not load the style list.',
  'Нет стилей для импорта': 'No styles to import',
  'В других проектах пока нет сохранённых стилей карты, или все они уже в этом проекте.': 'Other projects have no saved map styles, or all of them are already in this project.',
  'Поле для подписи': 'Label field',
  'Отдельное поле': 'Separate field',
  'Настройки для публичной карты': 'Public map settings',
  'Показывать слой на публичной карте': 'Show layer on public map',
  'Отображать в панели слоёв': 'Show in layers panel',
  'Тумблер включения/выключения': 'Visibility toggle',
  'По умолчанию:': 'Default:',
  'Включён': 'On',
  'Выключен': 'Off',
  'Иконка слоя': 'Layer icon',
  'Без иконки': 'No icon',
  'Загруженная иконка': 'Uploaded icon',
  'Использовать символ точек': 'Use point symbol',
  'Загрузить...': 'Upload...',
  'Показывать легенду': 'Show legend',
  'Показывать превью': 'Show preview',
  'Превью доступно только если в схеме слоя есть параметр типа «Обложка».': 'Preview is available only when the layer schema has a Cover property.',
  'Описание слоя': 'Layer description',
  'Объекты кликабельны': 'Features are clickable',
  'Высота (м)': 'Height (m)',
  'Масштаб': 'Scale',
  'Поворот (°): X, Y, Z': 'Rotation (°): X, Y, Z',
  'Авто': 'Auto',
  'бинов': 'bins',
  'zoom-зависимый': 'zoom-based',
  'Точка с превью': 'Preview point',
  'Форма': 'Shape',
  'Якорь превью': 'Preview anchor',
  'Параметр-обложка': 'Cover property',
  'Добавьте параметр типа «Обложка» в схему данных слоя ниже.': 'Add a Cover property to the layer data schema below.',
  'Без изображения': 'No image',
  'Размер (радиус)': 'Size (radius)',
  'Толщина обводки (0 = без обводки)': 'Stroke width (0 = no stroke)',
  'Цвет обводки берётся из палитры «Раскраска по параметру».': 'Stroke color comes from the Color by property palette.',
  'Показать фон': 'Show background',
  'Ничего не найдено': 'Nothing found',
  'зум': 'zoom',
  'Изменение по зуму': 'Zoom-based styling',
  'Отключить': 'Disable',
  'База:': 'Base:',
  'Добавить точку': 'Add stop',
  'Новый слой {number}': 'New layer {number}',
  'Растровый слой {number}': 'Raster layer {number}',
  'Новый 3D-слой {number}': 'New 3D layer {number}',
  'уникальное значение': 'unique value',
  'уникальных значения': 'unique values',
  'уникальных значений': 'unique values',
  'Свои цвета по значениям': 'Custom colors by value',
  'Цвета по значениям': 'Colors by value',
  'числа': 'numbers',
  'строки': 'strings',
  'изображение': 'image',
  'изображений': 'images',
  'Настроить изменение по зуму (на карте применяется плавно через text-translate)': 'Configure zoom-based styling (applied smoothly on the map with text-translate)',
  'Убрать изменение по зуму': 'Remove zoom-based styling',
  'Цвет диапазона {number}': 'Range {number} color',
  'Выбор цвета: {label}': 'Choose color: {label}',
  'Изменить ширину панели слоёв': 'Resize layers panel',
  'Объект': 'Feature',
  'Объект {number}': 'Feature {number}',
  'Изображение {number}': 'Image {number}',
  'Слой {name}': 'Layer {name}',
  'Объекты ({count})': 'Features ({count})',
  'Точка': 'Point',
  'Линия': 'Line',
  'Полигон': 'Polygon',
  'Выбор': 'Select',
  'Свободная линия': 'Freehand line',
  'Круг': 'Circle',
  'Прямоугольник': 'Rectangle',
  'Комментарий': 'Comment',
  'Импорт GeoJSON': 'Import GeoJSON',
  'Импорт OSM зданий': 'Import OSM buildings',
  'Название проекта': 'Project name',
  'Без названия': 'Untitled',
  'Загрузка...': 'Loading...',
  'Импорт данных': 'Import data',
  'Загрузите геоданные (GeoJSON, KML, KMZ), 3D-модели (gltf/glb) или фотографии. Фотографии можно импортировать как точки с превью или растровые оверлеи.': 'Upload geodata (GeoJSON, KML, KMZ), 3D models (gltf/glb), or photos. Photos can be imported as points with previews or raster overlays.',
  'Закрыть': 'Close',
  'Импортировать': 'Import',
  'Чтение GPS-данных из фотографий...': 'Reading GPS data from photos...',
  'Импортировать с привязкой к GPS-координатам': 'Use GPS coordinates',
  '{withGps} из {total} фото содержат GPS (прочитано в браузере)': '{withGps} of {total} photos contain GPS data (read in the browser)',
  '· для HEIC/HEIF координаты дополнительно проверяются на сервере при загрузке': '· HEIC/HEIF coordinates are additionally checked on the server during upload',
  'HEIC/HEIF: GPS читается на сервере при загрузке; если координаты есть в метаданных, точки встанут по ним': 'HEIC/HEIF: GPS data is read on the server during upload; points will use coordinates found in metadata',
  'Ни одно из выбранных фото не содержит GPS-данных. Все точки будут размещены в центре текущей области карты.': 'None of the selected photos contain GPS data. All points will be placed in the center of the current map view.',
  '{count} фото без GPS — будут размещены в центре слоя:': '{count} photos without GPS will be placed in the center of the layer:',
  'Перетащите файлы сюда': 'Drop files here',
  'Геоданные: .geojson, .json, .zip, .kml, .kmz': 'Geodata: .geojson, .json, .zip, .kml, .kmz',
  'Фотографии: .jpg, .jpeg, .png, .webp': 'Photos: .jpg, .jpeg, .png, .webp',
  '3D-модели: .gltf, .glb': '3D models: .gltf, .glb',
  'Добавить файлы к текущему выбору': 'Add files to the current selection',
  'Выбрать файл для импорта': 'Choose a file to import',
  'Нажмите для выбора файла': 'Click to choose a file',
  'Можно кликнуть сюда или перенести файлы, чтобы добавить к выбору': 'Click here or drop more files to add them to the selection',
  'Файл': 'File',
  '{count} файлов': '{count} files',
  '{count} файлов выбрано': '{count} files selected',
  'Загрузка... {current} / {total}': 'Uploading... {current} / {total}',
  'Импортировано точек: {count}': 'Points imported: {count}',
  'Изображения добавлены в выбранный слой': 'Images added to the selected layer',
  'Модель добавлена в выбранный слой': 'Model added to the selected layer',
  'Создано слоёв: {count}': 'Layers created: {count}',
  'Импорт завершен с предупреждениями: {count}': 'Import completed with {count} warnings:',
  '{count} фото без GPS размещено в центре слоя': '{count} photos without GPS were placed in the center of the layer',
  'Выбрано {count} фото. Как импортировать?': '{count} photos selected. How should they be imported?',
  'Точки с превью': 'Points with previews',
  'Каждое фото — объект на карте с изображением': 'Each photo becomes a map feature with an image',
  'Растровые оверлеи': 'Raster overlays',
  'Каждое фото — отдельный слой на карте': 'Each photo becomes a separate map layer',
  'OSM здания': 'OSM buildings',
  'Укажите корректный bbox (west,south,east,north)': 'Enter a valid bbox (west,south,east,north)',
  'Выберите область на карте и импортируйте здания из OpenStreetMap': 'Select a map area and import buildings from OpenStreetMap',
  'Источник области': 'Area source',
  'Текущая область на карте': 'Current map view',
  'Ввести вручную': 'Enter manually',
  'Текущая область на карте:': 'Current map view:',
  'Нет данных области карты — сдвиньте карту или выберите «Ввести вручную».': 'Map bounds are unavailable — move the map or choose “Enter manually”.',
  'Введите bbox: west, south, east, north': 'Enter bbox: west, south, east, north',
  'Некорректный формат. Используйте: west,south,east,north': 'Invalid format. Use: west,south,east,north',
  '✓ Область:': '✓ Area:',
  'Примечание:': 'Note:',
  'Импорт может занять время в зависимости от размера области. Большие области могут содержать тысячи зданий.': 'Import time depends on the area size. Large areas may contain thousands of buildings.',
  'Чтение данных...': 'Reading data...',
  'Добавить на карту': 'Add to map',
  'Нет доступа к геолокации. Разрешите доступ в настройках браузера и macOS.': 'Location access is denied. Allow it in your browser and macOS settings.',
  'Не удалось определить координаты. Включите Wi‑Fi и службы геолокации.': 'Could not determine your location. Turn on Wi-Fi and location services.',
  'Геолокация не ответила вовремя. Попробуйте ещё раз.': 'Location timed out. Please try again.',
  'Не удалось определить местоположение.': 'Could not determine your location.',
  'Карта ещё не готова': 'The map is not ready yet',
  'Показано приблизительное место по IP: на компьютере точная геолокация через браузер часто недоступна.': 'Showing an approximate IP-based location. Precise browser location is often unavailable on desktop.',
  'Карта недоступна': 'Map unavailable',
  'Приблизительное местоположение по IP': 'Approximate IP-based location',
  'Ваше местоположение': 'Your location',
  'Навигация по карте': 'Map navigation',
  'Приблизить': 'Zoom in',
  'Отдалить': 'Zoom out',
  'Перетащите для поворота карты; короткий клик — сброс на север и наклон': 'Drag to rotate the map; click to reset north and pitch',
  'Перетащите для поворота карты; короткий клик — сброс на север': 'Drag to rotate the map; click to reset north',
  'Геолокация': 'Geolocation',
  'Показать моё местоположение': 'Show my location',
  'Стиль карты': 'Map style',
  'Настроить свой стиль': 'Create custom style',
  'Сгенерировать свой стиль': 'Generate custom style',
  'Добавить из другого проекта': 'Add from another project',
  'Сохранить': 'Save',
  'Сохранить стиль': 'Save style',
  'Редактировать стиль': 'Edit style',
  'Удалить стиль': 'Delete style',
  'Шрифт на карте': 'Map font',
  'Удалить стиль?': 'Delete style?',
  'Свой стиль': 'Custom style',
  'Стиль «{name}» будет удалён. Это действие нельзя отменить.': '“{name}” will be deleted. This action cannot be undone.',
  'Удалить': 'Delete',
  'Показывать зум и компас': 'Show zoom and compass',
  'Запретить наклон и поворот карты': 'Disable map pitch and rotation',
  'Позиция камеры': 'Camera position',
  'Долгота': 'Longitude',
  'Широта': 'Latitude',
  'Наклон': 'Pitch',
  'Поворот': 'Bearing',
  'Зум': 'Zoom',
  'Мин. зум': 'Min zoom',
  'Макс. зум': 'Max zoom',
  'Сохранение...': 'Saving...',
  'Обновить позицию карты': 'Update map position',
  'Сохранить позицию карты': 'Save map position',
  'Сохранённая позиция используется как начальный вид при открытии проекта.': 'The saved position is used as the initial view when the project opens.',
  'Цвет области за пределами изображения': 'Color outside the image area',
  'Отступ за край изображения в долях его размера. 0 — нельзя выйти за край, 0.5 — можно отойти на половину ширины/высоты (по умолчанию).': 'Padding beyond the image edge as a fraction of its size. 0 prevents panning beyond the edge; 0.5 allows half the image width or height (default).',
  'Цвет фона': 'Background color',
  'Справка: цвет фона': 'Help: background color',
  'Выбор цвета фона подложки': 'Choose map background color',
  'HEX цвета фона подложки': 'Map background HEX color',
  'Фоновое изображение': 'Background image',
  'Фон карты': 'Map background',
  'Заменить': 'Replace',
  'Загрузить фоновое изображение': 'Upload background image',
  'Нажмите для загрузки': 'Click to upload',
  'Ограничение панорамирования': 'Panning bounds',
  'Справка: ограничение панорамирования': 'Help: panning bounds',
  'Отступ ограничения панорамирования': 'Panning bounds padding',
  'На главную': 'Back to dashboard',
  'Кликните для редактирования': 'Click to edit',
  'Слои': 'Layers',
  'Добавить слой': 'Add layer',
  '📄 Новый слой': '📄 New layer',
  '🗺️ Растровый слой': '🗺️ Raster layer',
  '📦 Новый 3D-слой': '📦 New 3D layer',
  '🔌 Интеграция': '🔌 Integration',
  'Нет слоёв': 'No layers',
  'Добавьте первый слой через кнопку «+» в заголовке панели.': 'Add your first layer with the “+” button in the panel header.',
  'Центрировать на объекте': 'Zoom to feature',
  'Показать объект': 'Show feature',
  'Скрыть объект': 'Hide feature',
  'Свернуть': 'Collapse',
  'Развернуть': 'Expand',
  'Центрировать на слое': 'Zoom to layer',
  'Разблокировать слой': 'Unlock layer',
  'Заблокировать слой': 'Lock layer',
  'Скрыть слой': 'Hide layer',
  'Показать слой': 'Show layer',
  'Нет объектов': 'No features',
  'Библиотека': 'Library',
  'Шрифты': 'Fonts',
  'Возвращаю шрифт': 'Restoring font',
  'Поддерживаются форматы TTF и OTF': 'TTF and OTF formats are supported',
  'Ошибка загрузки': 'Upload failed',
  'Загрузить': 'Upload',
  'Возвращаю шрифт {font}': 'Restoring {font}',
  'Удалить шрифт «{font}»?': 'Delete “{font}”?',
  'Владелец': 'Owner',
  'Редактор': 'Editor',
  'Просмотр': 'Viewer',
  '(ожидает)': '(pending)',
  'Удалить доступ': 'Remove access',
  'Неверный пароль. Проверьте ввод и попробуйте ещё раз.': 'Incorrect password. Check it and try again.',
  'Не удалось передать владение': 'Could not transfer ownership',
  'Вы уверены? После передачи вы потеряете права владельца.': 'Are you sure? You will lose owner permissions after the transfer.',
  'Подтвердите пароль': 'Confirm your password',
  'Текущий пароль от аккаунта': 'Current account password',
  'Подтвердить': 'Confirm',
  'Отмена': 'Cancel',
  'Выбрать нового владельца...': 'Select a new owner...',
  'Передать': 'Transfer',
  'Не удалось добавить участника': 'Could not add member',
  'Доступ к проекту': 'Project access',
  'Пригласить по email': 'Invite by email',
  'Пригласить': 'Invite',
  'Свойства': 'Properties',
  '3D-модель': '3D model',
  'Изображение': 'Image',
  'Слой': 'Layer',
  'Карта': 'Map',
  'Сохраняем…': 'Saving…',
  'Сохранено': 'Saved',
  'Ошибка сохранения': 'Save failed',
  'Поделиться': 'Share',
  'Дублировать объект': 'Duplicate feature',
  'Удалить объект': 'Delete feature',
  'Удалить объекты ({count})': 'Delete features ({count})',
  'Дублировать слой': 'Duplicate layer',
  'Дублировать в другой проект': 'Duplicate to another project',
  'Дублировать в проект': 'Duplicate to project',
  'Других проектов нет': 'No other projects',
  'Не удалось загрузить проекты': 'Failed to load projects',
  'Удалить слой': 'Delete layer',
  'Скопировать': 'Copy',
  'Управление доступом к проекту и публикация карты.': 'Manage project access and publish the map.',
  'Доступ': 'Access',
  'Публикация': 'Publishing',
  'Публичный доступ': 'Public access',
  'Любой, у кого есть ссылка, сможет видеть карту': 'Anyone with the link can view the map',
  'Публичная ссылка': 'Public link',
  'Ссылка на карту': 'Map link',
  'Встраивание на сайт': 'Embed on a website',
  'HTML-код для вставки': 'Embed HTML',
  'Настройки интерфейса карты': 'Map interface settings',
  'Панель фильтров': 'Filters panel',
  'Показывать панель слоёв и фильтров': 'Show the layers and filters panel',
  'Стиль интерфейса': 'Interface style',
  'Светлая / тёмная': 'Light / dark',
  'Тема интерфейса карты': 'Map interface theme',
  'Шрифты интерфейса': 'Interface fonts',
  'Загрузите шрифты в библиотеку, чтобы использовать их в интерфейсе карты': 'Upload fonts to the library to use them in the map interface',
  'Заголовки': 'Headings',
  'Текст': 'Text',
  'Комментарии': 'Comments',
  'Разрешить посетителям оставлять комментарии': 'Allow visitors to leave comments',
  'Публичная карта: добавление маркеров с текстом или реакцией': 'Public map: add markers with text or a reaction',
  'Показывать комментарии посетителям': 'Show comments to visitors',
  'Загрузка и отображение маркеров на публичной карте': 'Load and display markers on the public map',
  'Разрешить ответы на комментарии': 'Allow replies to comments',
  'Только при включённом показе комментариев': 'Only when comments are visible',
  'Название': 'Name',
  'Заголовок карточки': 'Card title',
  'Подпись на карте': 'Map label',
  'Подпись': 'Label',
  'Выбрано объектов: {count}. Изменения параметров применяются ко всем выбранным.': '{count} features selected. Property changes apply to all selected features.',
  'Выделено {count}': '{count} selected',
  'Нет свойств': 'No properties',
  'Свойства объекта недоступны для слоёв из векторных тайлов.': 'Feature properties are unavailable for vector tile layers.',
  'Тип геометрии': 'Geometry type',
  'Иконка': 'Icon',
  'Параметр': 'Property',
  'Тип визуализации': 'Visualization type',
  'Название слоя': 'Layer name',
  'Диапазон зума': 'Zoom range',
  'Карточка объекта': 'Feature card',
  'Показывать координаты': 'Show coordinates',
  'Кнопка «Поделиться»': 'Share button',
  'Подписи': 'Labels',
  'Угол поворота': 'Rotation angle',
  'Угол обзора': 'Field of view',
  'Изменение по зуму включено': 'Zoom-based styling is enabled',
  'Настроить изменение по зуму': 'Configure zoom-based styling',
  'Генерируем тайлы публичной карты…': 'Generating public map tiles…',
  'Тайлы публичной карты готовы': 'Public map tiles are ready',
  'Изменения сохранены — тайлы обновятся автоматически': 'Changes saved — tiles will update automatically',
  'Тайлы публичной карты': 'Public map tiles',
  'Тип карты': 'Map type',
  'Прогресс': 'Progress',
  'читаем данные...': 'reading data...',
  'генерируем тайлы...': 'generating tiles...',
  'загружаем...': 'uploading...',
  'в очереди': 'queued',
  'ожидает обновления': 'waiting for update',
  'Нет публичных векторных слоёв для генерации тайлов.': 'There are no public vector layers to generate tiles for.',
  'Дополнительные опции': 'Advanced options',
  'Цвет обводки': 'Stroke color',
  'Прозрачность': 'Opacity',
  'Мин. яркость': 'Min brightness',
  'Макс. яркость': 'Max brightness',
  'Насыщенность': 'Saturation',
  'Контраст': 'Contrast',
  'Цвет': 'Color',
  'Радиус': 'Radius',
  'Размытие': 'Blur',
  'Ширина обводки': 'Stroke width',
  'Прозрачность обводки': 'Stroke opacity',
  'Смещение [x,y]': 'Offset [x,y]',
  'Масштаб при наклоне': 'Pitch scale',
  'Выравнивание при наклоне': 'Pitch alignment',
  'Ключ сортировки': 'Sort key',
  'Цвет заливки': 'Fill color',
  'Прозрачность заливки': 'Fill opacity',
  'Цвет обводки (контур)': 'Outline color',
  'Толщина обводки': 'Stroke width',
  'Сглаживание': 'Antialiasing',
  'Якорь смещения': 'Offset anchor',
  'Паттерн (спрайт)': 'Pattern (sprite)',
  'Цвет линии': 'Line color',
  'Ширина': 'Width',
  'Зазор': 'Gap',
  'Смещение': 'Offset',
  'Штрих (массив)': 'Dash array',
  'Градиент (выражение)': 'Gradient (expression)',
  'Окончание линии': 'Line cap',
  'Соединение линий': 'Line join',
  'Предел miter': 'Miter limit',
  'Предел round': 'Round limit',
  'Высота': 'Height',
  'м': 'm',
  'Основание': 'Base',
  'Вертикальный градиент': 'Vertical gradient',
  'Вес': 'Weight',
  'Интенсивность': 'Intensity',
  'Цвет (выражение)': 'Color (expression)',
  'Размер иконки': 'Icon size',
  'Якорь иконки': 'Icon anchor',
  'Смещение иконки [x,y]': 'Icon offset [x,y]',
  'Поворот иконки': 'Icon rotation',
  'Отступ иконки': 'Icon padding',
  'Перекрытие иконок': 'Allow icon overlap',
  'Игнорировать размещение': 'Ignore placement',
  'Иконка опциональна': 'Icon optional',
  'Выравн. при наклоне': 'Pitch alignment',
  'Выравн. при повороте': 'Rotation alignment',
  'Шрифт': 'Font',
  'Размер текста': 'Text size',
  'Макс. ширина': 'Max width',
  'Высота строки': 'Line height',
  'Межбуквенный': 'Letter spacing',
  'Якорь текста': 'Text anchor',
  'Поворот текста': 'Text rotation',
  'Выравнивание текста': 'Text justification',
  'Перекрытие текста': 'Allow text overlap',
  'Игнорировать размещ.': 'Ignore placement',
  'Отступ текста': 'Text padding',
  'Трансформация текста': 'Text transform',
  'Выравн. текста (наклон)': 'Text pitch alignment',
  'Выравн. текста (поворот)': 'Text rotation alignment',
  'Переменный якорь (массив)': 'Variable anchor array',
  'Радиальное смещение': 'Radial offset',
  'Смещения якорей (выражение)': 'Anchor offsets (expression)',
  'Макс. угол': 'Max angle',
  'Держать текст вертикально': 'Keep text upright',
  'Текст опционален': 'Text optional',
  'Размещение символа': 'Symbol placement',
  'Интервал символов': 'Symbol spacing',
  'Избегать краёв тайла': 'Avoid tile edges',
  'Порядок по Z': 'Z order',
  'Цвет текста': 'Text color',
  'Прозрачность текста': 'Text opacity',
  'Цвет ореола текста': 'Text halo color',
  'Ширина ореола': 'Halo width',
  'Размытие ореола': 'Halo blur',
  'Якорь смещения текста': 'Text offset anchor',
  'Цвет иконки': 'Icon color',
  'Прозрачность иконки': 'Icon opacity',
  'Цвет ореола иконки': 'Icon halo color',
  'Ширина ореола иконки': 'Icon halo width',
  'Размытие ореола иконки': 'Icon halo blur',
  'Поворот оттенка': 'Hue rotation',
  'Ресемплинг': 'Resampling',
  'Длительность затухания': 'Fade duration',
  'мс': 'ms',
  'Символ': 'Symbol',
  '3D-объект': '3D object',
  'Тепловая карта': 'Heatmap',
  'Растр': 'Raster',
  'Размер': 'Size',
  'Квадрат': 'Square',
  'Пин': 'Pin',
  'Свободная': 'Freehand',
  'Макет Автокрафта': 'Autocraft layout',
  'Генератор': 'Generator',
  'Выберите генератор': 'Select generator',
  'Загружаем поля…': 'Loading fields…',
  'Заполнить данные ({count})': 'Fill in data ({count})',
  'Сгенерировать PDF': 'Generate PDF',
  'Сгенерированный макет': 'Generated layout',
  'Превью макета': 'Layout preview',
  'Открыть PDF': 'Open PDF',
  'Данные макета': 'Layout data',
  'Заполните поля — Автокрафт соберёт PDF для этой точки.': 'Fill in the fields — Autocraft will build a PDF for this point.',
  'Заполните поля — превью макета обновится после ввода.': 'Fill in the fields — the layout preview updates after you edit.',
  'Выберите значение': 'Select value',
  'Новая интеграция': 'New integration',
  'Подключение: {name}': 'Connect: {name}',
  'Заполните параметры. Данные доступа хранятся зашифрованными и наружу не отдаются.': 'Fill in the parameters. Access credentials are stored encrypted and are never exposed.',
  'Выберите готовый сервис или подключите свой API.': 'Choose a ready-made service or connect your own API.',
  'Публичная таблица по ссылке → слой точек. Координаты берутся из колонок.': 'Public spreadsheet via link → point layer. Coordinates are read from columns.',
  'Свой API': 'Custom API',
  'Произвольный REST/GeoJSON эндпоинт. Вы вводите URL и (опц.) доступ.': 'Arbitrary REST/GeoJSON endpoint. Enter the URL and optionally credentials.',
  'Автокрафт': 'Autocraft',
  'Генераторы PDF из проекта Автокрафта → прямоугольные макеты на карте.': 'PDF generators from an Autocraft project → rectangular layouts on the map.',
  'Ссылка на таблицу': 'Spreadsheet link',
  'Доступ открыт «любому, у кого есть ссылка».': 'Access must be open to "anyone with the link".',
  'gid листа (опц.)': 'Sheet gid (optional)',
  'Формат ответа': 'Response format',
  'JSON-массив записей': 'JSON array of records',
  'Путь к массиву (для записей)': 'Array path (for records)',
  'Точечный путь к массиву в JSON, если формат — записи.': 'Dot path to the array in JSON when the format is records.',
  'URL для записи (push, опц.)': 'Write URL (push, optional)',
  'Куда отправлять FeatureCollection слоя при push (двусторонняя sync).': 'Where to send the layer FeatureCollection on push (two-way sync).',
  'Метод записи': 'Write method',
  'Authorization (опц.)': 'Authorization (optional)',
  'Уйдёт заголовком запроса, хранится зашифрованным.': 'Sent as a request header, stored encrypted.',
  'Колонка долготы': 'Longitude column',
  'Колонка широты': 'Latitude column',
  'Поле id (опц., для стабильной синхронизации)': 'Id field (optional, for stable sync)',
  'Назад': 'Back',
  'Подключить': 'Connect',
  'Не удалось создать интеграцию.': 'Could not create integration.',
  'Ссылка на проект': 'Project link',
  'Вставьте полную ссылку, которую сгенерировал Автокрафт. Секрет будет храниться зашифрованно.': 'Paste the full link generated by Autocraft. The secret will be stored encrypted.',
  'Получить генераторы': 'Fetch generators',
  'Доступно генераторов: {count}': '{count} generators available',
  'Создать слой': 'Create layer',
  'Не удалось получить генераторы.': 'Could not fetch generators.',
  'Не удалось подключить Автокрафт.': 'Could not connect Autocraft.',

  // Табличный редактор данных слоя
  'Открыть таблицу': 'Open table',
  'Закрыть таблицу': 'Close table',
  'Изменить высоту таблицы': 'Resize table panel',
  'Меню колонки': 'Column menu',
  'По возрастанию': 'Ascending',
  'По убыванию': 'Descending',
  'Поиск в колонке': 'Search in column',
  'Фильтр': 'Filter',
  'Убрать фильтр': 'Remove filter',
  'Сбросить фильтр': 'Clear filter',
  'Сбросить всё': 'Clear all',
  'Изменить поле': 'Edit field',
  'Удалить поле': 'Delete field',
  'Добавить поле': 'Add field',
  'Название поля': 'Field name',
  'Тип поля': 'Field type',
  'Поле с таким именем уже есть': 'A field with this name already exists',
  'Опции (по одной на строку)': 'Options (one per line)',
  'Удаление опции очистит её у всех объектов слоя': 'Removing an option clears it from all layer features',
  'Колонка исчезнет из таблицы и карточек объектов слоя.': 'The column will disappear from the table and feature cards.',
  'Удалить строку': 'Delete row',
  'Удалить строки': 'Delete rows',
  'Нет полей': 'No fields',
  'Добавьте первое поле — колонки таблицы появятся здесь.': 'Add the first field — table columns will appear here.',
  'Загрузка…': 'Loading…',
  'Загружено': 'Loaded',
  'Загрузить все': 'Load all',
  'из': 'of',
  'объектов': 'features',
  'Все': 'All',
  'Да': 'Yes',
  'Нет': 'No',
  'Заполнено': 'Has value',
  'Пусто': 'Empty',
  'Нет значений': 'No values',

  // --- Презентации ---
  'Презентация': 'Presentation',
  'Предпросмотр': 'Preview',
  'Слайд': 'Slide',
  'Слайды': 'Slides',
  'Создайте первый слайд': 'Create your first slide',
  'Создать слайд': 'Create slide',
  'Текущий вид карты станет его камерой': 'The current map view will become its camera',
  'Выберите слайд, чтобы настроить его': 'Select a slide to edit it',
  'Дублировать': 'Duplicate',
  'Переименовать': 'Rename',
  'Камера': 'Camera',
  'Записать текущий вид': 'Save current view',
  'Записать': 'Save',
  'Вид изменён': 'View changed',
  'Перелететь к виду': 'Fly to view',
  'Переход': 'Transition',
  'Переход от предыдущего слайда к этому': 'Transition from the previous slide to this one',
  'с': 's',
  'Оформление': 'Appearance',
  'Затемнение карты': 'Map dimming',
  'Появление блоков': 'Block animation',
  'Опции': 'Options',
  'Блоки': 'Blocks',
  'Добавить блок': 'Add block',
  'Удалить блок': 'Delete block',
  'Пустой блок': 'Empty block',
  'Пустой блок — заполните его в панели справа': 'Empty block — fill it in the right panel',
  'Заголовок': 'Title',
  'Текст истории...': 'Story text...',
  'Картинка': 'Image',
  'Убрать картинку': 'Remove image',
  'Позиция': 'Position',
  'Тема': 'Theme',
  'Объекты слайда': 'Slide objects',
  'Сбросить': 'Reset',
  'На слайде': 'On slide',
  'Скрыт на этом слайде': 'Hidden on this slide',
  'Подсветить на этом слайде': 'Highlight on this slide',
  'Навести камеру на объект': 'Point camera at object',
  'Перейти': 'Go to',
  'Стиль и данные объекта — в режиме «Редактор»': 'Object style and data are in Editor mode',
  'Настройки презентации': 'Presentation settings',
  'Зритель может исследовать карту': 'Viewer can explore the map',
  'Стрелки навигации': 'Navigation arrows',
  'Индикатор прогресса': 'Progress indicator',
  'Кнопка «Исследовать карту»': '“Explore map” button',
  'Настройки действуют в публичной презентации и предпросмотре': 'Settings apply to the public presentation and preview',
  'Поделиться презентацией': 'Share presentation',
  'Опубликовать презентацию': 'Publish presentation',
  'Презентация не опубликована': 'Presentation is not published',
  'Ссылка работает независимо от публичной ссылки на карту': 'The link works independently of the public map link',
  'Выйти из предпросмотра': 'Exit preview',
  'Без анимации': 'No animation',
  'Плавно': 'Fade',
  'Плавный': 'Ease',
  'Снизу': 'Bottom',
  'Снизу вверх': 'Slide up',
  'Слева': 'Left',
  'Справа': 'Right',
  'Центр': 'Center',
  'Экран': 'Fullscreen',
  'Светлая': 'Light',
  'Тёмная': 'Dark',
  'Пролёт': 'Fly',
  'Мгновенно': 'Instant',
  'Объект сейчас редактирует {name}': 'Being edited by {name}',
  // Настройки панелей на публичной карте (ViewerSettingsDialog)
  'Настройки панелей на публичной карте': 'Public map panel settings',
  'Как зрители видят панель и карточки мест': 'How viewers see the panel and place cards',
  'Карточки': 'Cards',
  'Список мест. Подходит для гайдов': 'A list of places. Great for guides',
  'Слои и фильтры': 'Layers & filters',
  'Для больших данных и аналитики': 'For big data and analytics',
  'Раскладка списка': 'List layout',
  'Крупный': 'Large',
  'Средний': 'Medium',
  'Компактный': 'Compact',
  'Без фото': 'No photo',
  'Основное поле': 'Primary field',
  'Второе поле': 'Secondary field',
  'Описание': 'Description',
  'Не показывать': 'Hide',
  'Кнопки-ссылки': 'Link buttons',
  'Показывать ссылки места кнопками в списке': 'Show place links as buttons in the list',
  'Карточка у точки': 'Card at the pin',
  'Открывать карточку рядом с пином, а не сбоку': 'Open the card next to the pin instead of the side panel',
  // Виды пинов (PIN_MODES, карточка места)
  'Фото': 'Photo',
  'Событие': 'Event',
  'Ссылка': 'Link',
  'Иконка или эмодзи в пине секции': 'Section icon or emoji in the pin',
  'Фото-пины из обложек карточек': 'Photo pins from card covers',
  'Календарик с датой на пине': 'Calendar with the date on the pin',
  'Пин со значком ссылки': 'Pin with a link icon',

  // Язык подписей публичной карты (ViewerSettingsDialog)
  'Язык подписей на карте': 'Map label language',
  'Русский': 'Russian',

  // Панель-заглушка при ошибке рендера (PanelErrorBoundary)
  'Панель не загрузилась': 'The panel failed to load',
  'Перезагрузить страницу': 'Reload the page',
  // Пикер иконок: режим раскраски символа по параметру
  'Символ по параметру': 'Symbol by property',

  // Добавлено при мердже: ключи, которых нет в main
  'Визуализации': 'Visualizations',
  'Данные': 'Data',
  'Стиль': 'Style',
  'Способ показа': 'Display method',
  'Добавить визуализацию': 'Add visualization',
  'Удалить визуализацию': 'Delete visualization',
  'Показать визуализацию': 'Show visualization',
  'Скрыть визуализацию': 'Hide visualization',
  'Нарисуйте объект на карте или добавьте визуализацию заранее.': 'Draw an object on the map or add a visualization in advance.',
  'Выше': 'Move up',
  'Ниже': 'Move down',
  'Таблица объектов': 'Feature table',
  'Список': 'List',
  'Вид точек на карте': 'Point appearance on the map',
  'Пины': 'Pins',
  'Как зрители видят панель, список и точки на карте': 'How viewers see the panel, list, and points on the map',
  'На карте пока нет секций с местами': 'The map has no place sections yet',
  'Применяется ко всем секциям мест; точечные настройки мест остаются.': 'Applies to all place sections; per-place settings still override it.',
  'Название места под точкой на карте': 'Place name under the point on the map',
  'Подписи под пинами': 'Labels under pins',
  'URL сервера': 'Server URL',
  'GeoServer, ArcGIS Server и др. Можно вставить ссылку на GetCapabilities.': 'GeoServer, ArcGIS Server, etc. You can paste a GetCapabilities link.',
  'Логин (опц.)': 'Username (opt.)',
  'Пароль (опц.)': 'Password (opt.)',
  'Для приватных серверов доступ хранится зашифрованным; тайлы WMS идут через прокси.': 'For private servers, credentials are stored encrypted; WMS tiles go through a proxy.',
  'Найти слои': 'Find layers',
  'Не удалось получить список слоёв.': 'Failed to get the layer list.',
  'Не удалось импортировать слои.': 'Failed to import layers.',
  'WMS — картинка (растр), WFS — данные (вектор). Один слой часто есть в обоих.': 'WMS is an image (raster), WFS is data (vector). A layer is often available as both.',
  'Найдено:': 'Found:',
  'Поиск по названию или id': 'Search by name or id',
  'Выбрать все': 'Select all',
  'Снять все': 'Deselect all',
  'вектор': 'vector',
  'растр': 'raster',
  'Место': 'Place',
  'Маршрут': 'Route',
  'Ничего не выбрано': 'Nothing selected',
  'Выберите место в списке или на карте, чтобы изменить его свойства': 'Select a place in the list or on the map to edit its properties',
  'Места': 'Places',
  'Добавьте первое место': 'Add the first place',
  'Нажмите «Место» в тулбаре и кликните по карте': 'Click “Place” in the toolbar and click on the map',
  'Назад к списку': 'Back to list',
  'Секция': 'Section',
  'Действия с секцией': 'Section actions',
  'Удалить секцию': 'Delete section',
  'Удалить секцию «{name}» со всеми местами?': 'Delete section “{name}” with all its places?',
  'Настраивается в режиме «Редактор»': 'Configured in “Editor” mode',
  'У этих секций настроена раскраска или иконки по параметру — набор их перезапишет:': 'These sections have data-driven coloring or icons — applying the preset will overwrite them:',
  'Заменить настроенные стили?': 'Replace configured styles?',
  'Набор меняет подложку и стили секций. Отменить — Cmd+Z.': 'The preset changes the basemap and section styles. Undo with Cmd+Z.',
  'Ориентир (крупный пин)': 'Landmark (large pin)',
  'Поле': 'Field',
  'Новое поле': 'New field',
  'Например: Цена': 'e.g. Price',
  'Отображение': 'Display',
  'Скругление углов': 'Corner rounding',
  'Выкл': 'Off',
  'Свой цвет': 'Custom color',
  'Размер подписи': 'Label size',
  'Цвет подписи': 'Label color',
  'Стикеры': 'Stickers',
  'Эмодзи': 'Emoji',
  'Свой эмодзи': 'Custom emoji',
  'Выбрать': 'Choose',
  'ОК': 'OK',
  'Настройки просмотра': 'Viewer settings',
  'Следуете за': 'Following',
  'Перестать следовать': 'Stop following',
  'Сейчас в проекте': 'Currently in the project',
  'Выбрать дату': 'Pick a date',
  'дд.мм.гггг': 'dd.mm.yyyy',
  'Панель': 'Panel',
  'Панель справа': 'Right panel',
  'Попап': 'Popup',
  'Попап у точки': 'Popup at the point',
  'Показать карточку': 'Show card',
  'Карта ещё не готова — попробуйте ещё раз': 'The map is not ready yet — try again',
  'Не удалось создать слайд: {reason}': 'Failed to create slide: {reason}',
  'Показывать: {name}': 'Show: {name}',
  'Раскрыть: {name}': 'Expand: {name}',
  'Цвет: {name}': 'Color: {name}',
  'Применить ко всей секции': 'Apply to the whole section',
  'Гео-сервер (WMS/WFS)': 'Geo server (WMS/WFS)',
  'GeoServer, ArcGIS Server и др. Подключитесь к серверу и импортируйте слои массово.': 'GeoServer, ArcGIS Server, etc. Connect to a server and bulk-import layers.',
  'Можно вставить ссылку на GetCapabilities — параметры нормализуются автоматически.': 'You can paste a GetCapabilities link — the parameters are normalized automatically.',
  'Список мест с фото и описанием': 'A list of places with photos and descriptions',
  'Классическая панель слоёв': 'Classic layer panel',
  'Точки': 'Points',
  'Точки · обычные': 'Points · regular',
  'Точки · иконки': 'Points · icons',
  'Точки · с превью': 'Points · with preview',
  'Точки · теплокарта': 'Points · heatmap',
  'Линии': 'Lines',
  'Полигоны': 'Polygons',
  'Полигоны · заливка': 'Polygons · fill',
  'Полигоны · контур': 'Polygons · outline',
  'Полигоны · 3D': 'Polygons · 3D',
  'Разное': 'Misc',
  'Еда и напитки': 'Food & drink',
  'Еда': 'Food',
  'Напитки': 'Drinks',
  'Животные': 'Animals',
  'Природа': 'Nature',
  'Активности': 'Activities',
  'Транспорт': 'Transport',
  'Символы': 'Symbols',
  'Вещи': 'Objects',
  'Креатив': 'Creator',
};

export function editorText(
  source: string,
  params?: Record<string, string | number>,
): string {
  const template = typeof localStorage !== 'undefined' && localStorage.getItem('sloy-language') === 'en'
    ? (editorTranslationsEn[source] ?? source)
    : source;
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    Object.hasOwn(params, name) ? String(params[name]) : match,
  );
}
